import styled from 'styled-components/macro'
import Layout from '~layout'
import { BaseColor, LineHeight, rem, spacing, textEllipsis, themeColor, Typography } from '@unbounded/unbounded-components'

export const Container = styled(Layout.Header)`
  margin-top: ${spacing(-0.25)};
  color: ${themeColor(BaseColor.shade_50)};
`

export const InfoContainer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
`

export const Section = styled.div`
  flex-grow: 1;
  min-width: 0;
  margin-left: ${spacing(0.75)};
`

export const SubHeader = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${rem(2)};
`

export const Title = styled(Layout.Title)`
  &:only-child {
    line-height: ${rem(LineHeight.large)};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    // Fallback to -webkit-line-clamp
    max-height: ${rem(LineHeight.large * 2)};
    margin: ${rem(-2)} 0; // To be the same as image
  }

  &:not(:only-child) {
    ${textEllipsis};
  }
`

export const SubTitle = styled.div`
  min-width: 0;
  margin-left: ${rem(4)};
  ${Typography.labelMedium};
  ${Typography.textRegular};
  ${textEllipsis};
`

interface ImageContainerProps {
  isBright?: boolean
}

export const ImageContainer = styled.div<ImageContainerProps>`
  flex-shrink: 0;
  width: ${rem(42)};
  height: ${rem(42)};
  margin-top: ${rem(2)}; // To be same height as Header section
  border-radius: 50%;
  color: ${themeColor(BaseColor.shade_0)};
  background-color: ${({ isBright }) => (isBright === false ? 'transparent' : themeColor(BaseColor.shade_20))};
`
